// styles
import "./scss/main.scss";

// polyfills
import "core-js/fn/object/assign";
// import "core-js/fn/object/values";
// import "core-js/fn/array/find";
import "./polyfills/matches";
import "./polyfills/closest";

// components
import Diacart from "./components/Diacart";

export default Diacart;
